var _circle, _circle2, _circle3, _g, _path, _g2, _g3, _path2, _g4, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4309,
    cy: 19.9026,
    r: 8.43091,
    fill: "url(#paint0_linear_8643_18019)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4314,
    cy: 19.9025,
    r: 7.86885,
    stroke: "url(#paint1_linear_8643_18019)",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "1 1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8643_18019",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 12,
    width: 15,
    height: 16
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.4308,
    cy: 19.9025,
    r: 7.30679,
    fill: "#F3FCF4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8643_18019)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8643_18019)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.4308,
    cy: 19.9025,
    r: 7.30679,
    fill: "url(#paint2_radial_8643_18019)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.5583 27.8774L10.3486 11.8921H12.5323L12.3226 27.8774H10.5583Z",
    fill: "url(#paint3_linear_8643_18019)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.7834 27.7646L3.15039 15.7556L5.04148 14.6638L12.3114 26.8824L10.7834 27.7646Z",
    fill: "url(#paint4_linear_8643_18019)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.6017 26.8822L17.8716 14.6636L19.7626 15.7554L12.1297 27.7644L10.6017 26.8822Z",
    fill: "url(#paint5_linear_8643_18019)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.17871,
    y: 20.7686,
    width: 14.5053,
    height: 6.38668,
    fill: "url(#paint6_linear_8643_18019)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_8643_18019)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.4308,
    cy: 19.9025,
    r: 7.30679,
    fill: "#D8D9D9",
    fillOpacity: 0.01
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69083 7.03149H17.1964L19.8745 10.0666L11.4436 11.4718L3.0127 10.0666L5.69083 7.03149Z",
    fill: "url(#paint7_radial_8643_18019)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8643_18019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07124 4.3335H14.816L9.08295 11.0782L3.0127 10.0665L8.07124 4.3335Z",
    fill: "url(#paint8_radial_8643_18019)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75743 4.3335L4.69888 10.3475L3.0127 10.0665L8.07124 4.3335H9.75743Z",
    fill: "url(#paint9_linear_8643_18019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39648 10.7972L9.08267 11.0782L14.8157 4.3335H13.1295L7.39648 10.7972Z",
    fill: "url(#paint10_linear_8643_18019)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8643_18019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8165 4.3335H8.07172L13.8047 11.0782L19.875 10.0665L14.8165 4.3335Z",
    fill: "url(#paint11_radial_8643_18019)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1303 4.3335L18.1888 10.3475L19.875 10.0665L14.8165 4.3335H13.1303Z",
    fill: "url(#paint12_linear_8643_18019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4912 10.7972L13.805 11.0782L8.07201 4.3335H9.75819L15.4912 10.7972Z",
    fill: "url(#paint13_linear_8643_18019)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8643_18019",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 3,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4547 13.3264C11.4547 13.3264 11.4547 13.3264 11.4547 13.3264L11.4548 13.3264C11.4548 13.3264 11.4549 13.3264 11.4549 13.3263C11.4549 13.3263 11.4549 13.3263 11.4549 13.3263L12.1511 13.068C12.7818 12.8341 13.0414 12.0821 12.6895 11.5088L11.4549 9.49766C11.4549 9.49764 11.4549 9.49761 11.4549 9.49759L11.4549 9.49732C11.4549 9.49726 11.4548 9.49724 11.4548 9.49729C11.4548 9.49732 11.4547 9.49732 11.4547 9.49729L11.4547 9.49728C11.4546 9.49722 11.4546 9.49724 11.4546 9.49731L11.4546 9.49762C11.4546 9.49765 11.4546 9.49767 11.4545 9.4977L10.22 11.5089C9.86804 12.0822 10.1277 12.8341 10.7584 13.0681L11.4545 13.3263C11.4545 13.3263 11.4546 13.3263 11.4546 13.3264C11.4546 13.3264 11.4546 13.3264 11.4546 13.3264L11.4547 13.3264Z",
    fill: "url(#paint14_linear_8643_18019)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8643_18019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4644 13.4062L13.3623 12.6268L11.4644 9.20385L11.4644 13.4062Z",
    fill: "url(#paint15_linear_8643_18019)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4643 13.4065L9.56641 12.627L11.4643 9.20409L11.4643 13.4065Z",
    fill: "url(#paint16_linear_8643_18019)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17799 22.0377C9.94599 21.3977 10.558 20.8657 11.014 20.4417C11.47 20.0097 11.85 19.5617 12.154 19.0977C12.458 18.6337 12.61 18.1777 12.61 17.7297C12.61 17.3217 12.514 17.0017 12.322 16.7697C12.13 16.5377 11.834 16.4217 11.434 16.4217C11.034 16.4217 10.726 16.5577 10.51 16.8297C10.294 17.0937 10.182 17.4577 10.174 17.9217H8.54199C8.57399 16.9617 8.85799 16.2337 9.39399 15.7377C9.93799 15.2417 10.626 14.9937 11.458 14.9937C12.37 14.9937 13.07 15.2377 13.558 15.7257C14.046 16.2057 14.29 16.8417 14.29 17.6337C14.29 18.2577 14.122 18.8537 13.786 19.4217C13.45 19.9897 13.066 20.4857 12.634 20.9097C12.202 21.3257 11.638 21.8297 10.942 22.4217H14.482V23.8137H8.55399V22.5657L9.17799 22.0377Z",
    fill: "url(#paint17_linear_8643_18019)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8643_18019",
    x: 4.12402,
    y: 12.5957,
    width: 14.6133,
    height: 14.6135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.101961 0 0 0 0 0.105882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8643_18019"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_8643_18019",
    x: 4.12402,
    y: 12.5957,
    width: 14.6133,
    height: 14.6135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.725
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.231373 0 0 0 0 0.12549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8643_18019"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8643_18019",
    x: 3.0127,
    y: 0.333496,
    width: 19.8037,
    height: 14.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8643_18019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8643_18019",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8643_18019",
    x: 0.0712891,
    y: 0.333496,
    width: 19.8037,
    height: 14.7446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8643_18019"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8643_18019",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8643_18019",
    x1: 5.7822,
    y1: 13.4951,
    x2: 16.3208,
    y2: 26.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8643_18019",
    x1: 6.15922,
    y1: 13.9222,
    x2: 15.9953,
    y2: 26.3288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176138"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8643_18019",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4308 19.9025) rotate(90) scale(7.30679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8643_18019",
    x1: 11.4405,
    y1: 11.8921,
    x2: 11.4405,
    y2: 27.8774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8643_18019",
    x1: 5.17842,
    y1: 16.2922,
    x2: 11.5474,
    y2: 27.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8643_18019",
    x1: 17.7345,
    y1: 16.292,
    x2: 11.3656,
    y2: 27.3233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EDED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8643_18019",
    x1: 11.4314,
    y1: 23.538,
    x2: 11.4113,
    y2: 26.7597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176138"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_8643_18019",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.4436 9.25163) rotate(90) scale(2.22014 8.43091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_8643_18019",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.91433 7.70586) rotate(90) scale(3.37237 5.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8643_18019",
    x1: 4.12558,
    y1: 5.05518,
    x2: 7.76502,
    y2: 10.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8643_18019",
    x1: 8.62065,
    y1: 5.14286,
    x2: 12.728,
    y2: 10.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_8643_18019",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.9734 7.70586) rotate(90) scale(3.37237 5.90164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#176138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153B20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8643_18019",
    x1: 18.7621,
    y1: 5.05518,
    x2: 15.1227,
    y2: 10.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8643_18019",
    x1: 14.267,
    y1: 5.14286,
    x2: 10.1597,
    y2: 10.8417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8643_18019",
    x1: 11.5934,
    y1: 10.5373,
    x2: 10.2474,
    y2: 11.9941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8643_18019",
    x1: 13.0492,
    y1: 12.902,
    x2: 10.7288,
    y2: 11.5802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8643_18019",
    x1: 9.87955,
    y1: 12.9022,
    x2: 12.1999,
    y2: 11.5804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8643_18019",
    x1: 9.52209,
    y1: 16.0521,
    x2: 15.1093,
    y2: 20.7982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBFA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08E6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.ca71a58c182fa13500ac6b2bc2552f74.svg";
export { ForwardRef as ReactComponent };